module.exports = __webpack_public_path__ + "img/symbol_1.5fa08b0d.png";